export function getBaseUrl() {
  const localBaseUrl = "http://127.0.0.1:3000";
  const productionBaseUrl = "https://srv611025.hstgr.cloud/api";

  return productionBaseUrl;

  return process.env.NODE_ENV === "production"
    ? productionBaseUrl
    : localBaseUrl;
}
